<template>
  <a-modal
    width="600px"
    destroyOnClose
    :title="param.title"
    v-model="param.show"
    @ok="okMethod"
    :okButtonProps="param.okButtonProps"
    :cancelButtonProps="param.cancelButtonProps"
  >
    <div style="margin-bottom:20px;">
      <label>打印设备选择：</label>
      <a-select style="width:400px;" v-model="param.printer">
        <a-select-option v-for="v of param.printerList" :key="v" :value="v">{{v}}</a-select-option>
      </a-select>
    </div>
  </a-modal>
</template>

<script>
import tablefun from "@/public/tablefun"
export default {
  props: {
    param: Object,
  },
  methods: {
    okMethod() {
      if (this.param.okMethod) {
        this.param.okMethod(this.param.printer);
        this.param.show = false;
      } else {
        this.param.show = false;
      }
    }
  }
}
</script>
<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/modal/printerModal/index.vue